import React from 'react';
import { Box, Image, Text, VStack, useMediaQuery } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import LanguageSwitch from './LanguageSwitch';

const HeroSection = () => {
  const { t } = useTranslation();
  const [isMobileView] = useMediaQuery("(max-width: 991px)");
  const content = t('home', { returnObjects: true });

  return (
    <Box
      id="heroSection"
      textAlign={"center"}
      objectFit="cover"
      position="relative"
      bgImage={`url(${t('home.banner_images', { returnObjects: true })[0]})`}
      bgSize="cover"
      bgPosition="center"
      width="100%"
      display="flex"
      dir={"ltr"}
    >
      <VStack
        width={'100%'}
      >

        {/* introduction text */}
        <Box
          alignSelf={"center"}
          marginTop={isMobileView ? "5%" : "9%"}
          padding={isMobileView ? 2 : 0}
        >
          <Text color="white" fontSize={isMobileView ? "sm" : "xl"} fontWeight="600">
            {content.welcomeMessage}
          </Text>
          <Text margin="0 auto" width={isMobileView ? '100%' : '80%'} fontSize={isMobileView ? "md" : "2xl"} color="white" fontWeight="bold">
            {content.welcomeMessageDescription}
          </Text>
        </Box>


        {!isMobileView &&
          <Box position="absolute" top={'5%'} right={'1%'} pr={10} pt={10} >
            <LanguageSwitch />
          </Box>
        }

        {/* image and logo section */}
        <Box
          width={"100%"}
          flexDirection={'row'}
          display={"flex"}
          justifyContent={'space-between'}
          alignItems={'flex-end'}
          marginTop={isMobileView ? "5%" : "-10%"}
        >
          <Image
            src={t('home.banner_images', { returnObjects: true })[1]}
            alt="child"
            // position="absolute"
            width={{ base: 150, md: 200, lg: 400 }}
            bottom="0"
            left={"5%"}
          />

          <Image
            src={t('home.banner_images', { returnObjects: true })[2]}
            alt="partners"
            width={{ base: 120, md: 250, lg: 250 }}
            bottom={'5%'}
            marginBottom={'4%'}
            right={"5%"}
          />

        </Box>

      </VStack>
    </Box>
  );
};

export default HeroSection;
